import styled from "@emotion/styled";
import { Styles } from "@tpd-web-common-libs/nodejs-library";

export const ContainerDiv = styled.div<{
  "data-margin-top": string;
  "data-margin-bottom": string;
  "data-color-box": string;
  "data-color-box-mobile": string;
  "data-box-margin-top": string;
}>`
  margin-top: ${(props) => props["data-margin-top"]};
  margin-bottom: ${(props) => props["data-margin-bottom"]};
  position: relative;
  height: 570px;
  width: 100%;
  overflow: hidden;

  .image-wrapper {
    overflow: hidden;
    ${Styles.BreakpointsUtils.tabletAndDesktopOnly(`
      width: 100%;
      height: 100%;
    `)}
  }

  .tpd-image-container {
    height: 100%;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;

      ${Styles.BreakpointsUtils.desktopOnly(`
        height: 570px;
      `)}

      ${Styles.BreakpointsUtils.tabletOnly(`
        height: 470px;
      `)}

      ${Styles.BreakpointsUtils.mobileOnly(`
        height: 166px;
      `)}
    }
  }

  .visore-no-carosello-box {
    background-color: ${(props) => props["data-color-box"]};
    position: absolute;
    top: 15%;
    width: 408px;
    height: 351px;
    color: #fff;
    overflow: hidden;
    font-family: "Unipol";
    z-index: 3;

    &.right {
      right: 15%;
    }

    &.left {
      left: 15%;
    }

    &.hidden {
      display: none;
    }

    .box-content-wrapper {
      margin-top: ${(props) => props["data-box-margin-top"]};
      margin-left: 15%;
      margin-right: 9.5%;

      .box-title {
        margin-bottom: 20px;
        width: 80%;
        display: flex;
        align-items: center;
        ${Styles.BreakpointsUtils.desktopOnly(`
          align-items: start;
       `)}

        .text {
          font-family: "Unipol Bold";
          font-size: 22px;
          padding-top: 6px;
          text-transform: uppercase;
          ${Styles.BreakpointsUtils.desktopOnly(`
            padding-top: 2px;
        `)}
        }
        i {
          margin-right: 10px;
          font-size: 28px;
          font-weight: 400;
          line-height: 1;
        }
      }
      .box-subtitle {
        line-height: 28px;
        ${Styles.BreakpointsUtils.desktopOnly(`
        height: 120px;
        font-size: 25px;
        text-align: left;

        &.no-title {
          p {
            margin: 0 !important;
          }
        }

          .rich-text-container {
            h1 {
              font-size: 25px;
              margin: 0;
              line-height: 28px;
            }
            min-height: 200px;
            min-width: 340px;
            justify-content: start;
            overflow: hidden;
            p {
              margin: 0 15px 10px 0;
            }
            div {
              padding-right: 15px;
            }
          }
      `)};
      }
    }

    ${Styles.BreakpointsUtils.tabletOnly(`

      .box-content-wrapper {
        margin-top: 30px;
        .box-subtitle {
          .rich-text-container {
            overflow-x: hidden;
          }
        }
      }

      &.left {
        left: 10%;
      }
    `)}
  }

  ${Styles.BreakpointsUtils.tabletOnly(`
    height: 470px;

    .visore-no-carosello-box { 
      left: 10%;
      top: 21%;
      width: 312px;
      height: 264px;

      .box-content-wrapper {
        margin-left: 10%;

        .box-title {
          margin-bottom: 10px;
        }

        .box-subtitle {
          h1 {
            font-size: 22px;
            margin: 0;
          }
          font-size: 22px;
          width: 100%;
          text-align: left;
        }
      }
    }
  `)}

  ${Styles.BreakpointsUtils.mobileOnly(`
    height: auto;

    .image-wrapper {
      height: 166px;
    }

    .visore-no-carosello-box {
      background-color: #f1f1f1;
      color: #0169b4;
      ${Styles.PageColorUtils.pageColorThemeOnly(
        (pageColor: any) => `
          color: ${pageColor.mainColor};
          background-color: #f1f1f1;
        `
      )}
      width: 100%;
      position: static;
      left: 0;
      height: auto;

      .box-content-wrapper {
        margin: 0 auto;
        padding-top: 30px;
        ${Styles.BreakpointsUtils.mobileOnly(`
            display: flex;
            justify-content: center;
        `)}

        .box-title {
          position: absolute;
          top: 134px;
          margin: 0;
          justify-content: center;
          width: 100%;

          i {
            font-size: 25px;
            padding: 12px;
            border: 4px solid #fff;
            margin-right: 0;
          }

          .text {
            display: none;
          }

        }

        .box-subtitle {
          margin: 0 auto;
          width: 80%;
          text-align: center;
          h1 {
            font-size: 22px;
            line-height: 1.42857143;
            margin: 0;
          }
          font-size: 22px;
          line-height: 1.42857143;
          padding-bottom: 10px;
          ${Styles.BreakpointsUtils.mobileOnly(`
            margin: 0;
          `)}
        }
      }
    }
  `)}

  @media screen and (max-width: 767px) {
    .box-content-wrapper {
      color: ${(props) => props["data-color-box-mobile"]};
      .box-title {
        i {
          background-color: #0169b4;
          color: ${Styles.Themes.UnipolColors.white};
          ${Styles.PageColorUtils.pageColorThemeOnly(
            (pageColor: any) => `
                background-color: ${pageColor.mainColor};
                color: ${pageColor.invertedMainColor};
              `
          )}
          background-color: ${(props) => props["data-color-box-mobile"]};
        }
      }
    }
  }
`;

export const IFrameContainer = styled.div`
  width: 100%;
  height: 100%;
`;

export const TpdControlPlay = styled.div`
  z-index: 3;
  width: 100%;
  height: 160px;
  overflow: hidden;
  position: absolute;
  top: 35%;
  cursor: pointer;

  ${Styles.BreakpointsUtils.mobileOnly(`
    top: 0;
  `)}
`;

export const TpdPlay = styled.div`
  background: #000;
  opacity: 0.7;
  border-radius: 50%/10%;
  color: #fff;
  font-size: 0.96em;
  height: 3em;
  margin: 20px auto;
  position: relative;
  text-align: center;
  text-indent: 0.1em;
  transition: all 0.15s ease-out;
  width: 4em;
  top: 34px;

  :before {
    background: inherit;
    border-radius: 5%/50%;
    bottom: 9%;
    content: "";
    left: -5%;
    position: absolute;
    right: -5%;
    top: 9%;
  }

  :after {
    border-color: transparent transparent transparent #fff;
    border-style: solid;
    border-width: 1em 0 1em 1.732em;
    content: " ";
    font-size: 0.75em;
    height: 0;
    margin: -1em 0 0 -0.75em;
    top: 50%;
    position: absolute;
    width: 0;
  }

  :hover {
    background-color: red;
  }

  ${Styles.BreakpointsUtils.mobileOnly(`
    font-size: 0.7em;
  `)}
`;

export const TpdLinksContainer = styled.div<{ title; link1; link2 }>`
  display: flex;
  flex-direction: column;
  width: fit-content;

  ${Styles.BreakpointsUtils.desktopOnly(`
    margin-left: 30px;
    margin-top: ${(props) => {
      /** PT LOGIC */
      const oneOfTwoPresent =
        (props.link1 &&
          props.link1 !== "" &&
          !props.link2 &&
          props.link2 === "") ||
        (!props.link1 &&
          props.link1 === "" &&
          props.link2 &&
          props.link2 !== "");
      const bothPresent =
        props.link1 && props.link1 !== "" && props.link2 && props.link2 !== "";
      /** Title present */
      if (props.title && props.title !== "") {
        /** 2 links */
        if (bothPresent) {
          return "0";
          /** One of two links */
        } else if (oneOfTwoPresent) {
          return "50px";
        }
      }
      /** No title */
      return "50px";
    }};
  `)}

  ${Styles.BreakpointsUtils.mobileOnly(`
    width: 100%;
    align-items: center;
    justify-content: center;
    flex-direction: row;
  `)}
`;

export const TpdCtaBox = styled.div`
  display: block;
  width: fit-content;
  margin-bottom: 5px;
`;

export const TpdCta = styled.div`
  a {
    color: ${Styles.Themes.UnipolColors.blueOne};
    ${Styles.TouchpointUtils.touchpointThemeOnly(
      (touchpoint: any) => `
        color: ${touchpoint.mainColor};
      `
    )}
  }
  .tpd-cta-container {
    box-sizing: border-box;
    margin-bottom: 0;
    font-weight: 600;
    text-align: center;
    vertical-align: middle;
    background-image: none;
    border: 1px solid #979797;
    border-bottom: 5px solid #c4151c;
    white-space: nowrap;
    border-radius: 4px;
    user-select: none;
    border-radius: 0;
    height: 42px;
    font-family: Unipol Bold;
    font-size: 16px;
    background-color: #fff;
    min-height: 48px;
    line-height: 32px;
    display: inline-block;
    padding: 5px 35px;
    min-width: 170px;
  }

  p {
    margin: 0;
  }

  &:hover {
    color: #c4151c;
  }

  ${Styles.BreakpointsUtils.mobileOnly(`
    width: 95%;
  `)}
`;
